import React from 'react'
import './underline.css'
export function UnderLine({className}) {
  return (
    <div className={`underline ${className}`}></div>
  )
}
